import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import { MESSAGES } from "../../../common/Messages";
import { FillFilters, getAppSettings, loadDatasource } from '../../../common/Utils';
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    FilterRow,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import {
    SearchLayout,
    CollectionCreditTypeOptions,
    CollectionCreditStatusOptions,
    OpenFollowUpColumns,
    highlightOverdueFollowUpRow,
} from './Layout';
import CustomerBrowseGrid from './CustomerBrowseGrid';
import { ROUTES, GRID_KEYS, GRID_PAGE_SIZES, FORM_LAYOUTS, DEFAULT_LAYOUT_NAME } from './constants';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import '../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const filtersCollapsed = !!getAppSettings()?.FiltersCollapsed;
    const [selectedItems, setSelectedItems] = useState(filtersCollapsed ? [] : [searchpanel[0]]);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);
    const selectedCustomer = useRef(null);
    const [isStartFollowUpDisabled, setIsStartFollowUpDisabled] = useState(true);

    const gridKey = GRID_KEYS.FollowUpList;
    const [currentLayout, setCurrentLayout] = useState(DEFAULT_LAYOUT_NAME);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        Reference: '',
        Type: '',
        Status: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        const ref = formRefs.current?.[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);
    }, []);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        history.push(`${ROUTES.EDIT}?id=${rowId.current}`);
    };

    const followUpListUrl = `${window._env_.REACT_APP_APIS}/${data.CollectionCreditHeader.GetCollectionCreditHeaders}`;

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource(accessToken, followUpListUrl, 'RowId');
        const filters = FillFilters(formFields);
        datasource.filter(filters.length === 0 ? null : filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTimeout(() => {
            setResultData(loadDatasource(accessToken, followUpListUrl, 'RowId'));
        }, 100);
    };

    const handleFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("Type", CollectionCreditTypeOptions);
            loadLookupClient("Status", CollectionCreditStatusOptions);
        }, 100);
    }, [loadLookupClient]);

    const handleFieldChange = useCallback((name, value) => {
    }, []);

    const [resultData, setResultData] = useState(null);

    useEffect(() => {
        if (!resultData) {
            setResultData(loadDatasource(accessToken, followUpListUrl, 'RowId'));
        }
    }, []);

    // ============================================================
    // Customer tab: browse/pick a customer to start a new follow-up
    // ============================================================
    const onCustomerChanged = useCallback((customer) => {
        selectedCustomer.current = customer;
        setIsStartFollowUpDisabled(!customer);
    }, []);

    const handleStartFollowUpClick = () => {
        const customer = selectedCustomer.current;
        if (!customer) return;
        const params = new URLSearchParams({
            customerId: customer.id,
            customerIdentityId: customer.identityid || '',
        });
        history.push(`${ROUTES.ADD}?${params.toString()}`);
    };

    return (
        <div className="search-page-container">
            <TabPanel height={"auto"}>
                <TabItem title="Open Follow-up">
                    <div className="search-page-content">
                        <div id="accordion" className="search-page-accordion">
                            <AccordionReact
                                dataSource={searchpanel}
                                collapsible={true}
                                multiple={false}
                                animationDuration={300}
                                selectedItems={selectedItems}
                                onSelectionChanged={e => {
                                    if (e.currentTarget === e.target) {
                                        let newItems = [...selectedItems];
                                        e.removedItems.forEach((item) => {
                                            const index = newItems.indexOf(item);
                                            if (index >= 0) newItems.splice(index, 1);
                                        });
                                        if (e.addedItems.length) newItems = [...newItems, ...e.addedItems];
                                        setSelectedItems(newItems);
                                    }
                                }}
                                itemTitleRender={() => (
                                    <Toolbar className="accordian-toolbar">
                                        <Item location="before">
                                            <div className="title">
                                                <h6 style={{ color: window._env_.Color2 }}>
                                                    Enter Your Query For AR Credit/Collections Follow-up
                                                </h6>
                                            </div>
                                        </Item>
                                        <Item location="after">
                                            <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                        </Item>
                                        <Item location="after">
                                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                        </Item>
                                    </Toolbar>
                                )}
                                itemRender={() => (
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId={FORM_LAYOUTS.Search.id}
                                        layoutName={FORM_LAYOUTS.Search.name}
                                        defaultFormSchema={SearchLayout}
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleFormLoad}
                                        noSpacingBeforeFirstRow={true}
                                    />
                                )}
                                id="accordion-container" className="accordion-height"
                            />
                        </div>
                        <div className="search-page-grid-container">
                            <DataGrid
                                onExporting={(e) => {
                                    if (window.handleDevExtremeDataGridExport) window.handleDevExtremeDataGridExport(e);
                                }}
                                ref={dataGrid}
                                allowColumnReordering={true}
                                allowColumnResizing={true}
                                dataSource={resultData}
                                showBorders={true}
                                hoverStateEnabled={true}
                                className="search-page-grid"
                                onSelectionChanged={onSelectionChanged}
                                onRowPrepared={highlightOverdueFollowUpRow}
                                remoteOperations={true}
                                searchEnabled={true}
                                columnAutoWidth={true}
                            >
                                <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                                    <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
                                </ColumnChooser>
                                <Export enabled={true} allowExportSelectedData={true} />
                                <Selection mode="multiple" />
                                <Sorting visible={true} mode="multiple" />
                                <Paging defaultPageSize={10} />
                                <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={GRID_PAGE_SIZES} showNavigationButtons={true} />
                                <FilterRow visible={true} />
                                <StateStoring enabled={true} type="custom" customLoad={loadState} storageKey={gridKey} customSave={saveState} />
                                <GridToolbar>
                                    <GridToolbarItem location="before">
                                        <Button disabled={isEditButtonDisabled} onClick={handleEditClick} type="default" text="Edit"></Button>
                                    </GridToolbarItem>
                                    <GridToolbarItem location="before">
                                        <div>
                                            <Link to={ROUTES.ADD}>
                                                <Button type="default" className="gridTopButton" text="Create"></Button>
                                            </Link>
                                        </div>
                                    </GridToolbarItem>
                                    <GridToolbarItem location="after">
                                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} currentLayout={currentLayout} setCurrentLayout={setCurrentLayout} accessToken={accessToken} />
                                    </GridToolbarItem>
                                    <GridToolbarItem name="columnChooserButton" />
                                    <GridToolbarItem name="exportButton" />
                                </GridToolbar>

                                {/* Column set (and its default NextFollowUpDate sort) is shared with
                                    OpenFollowUpGrid via Layout.js's OpenFollowUpColumns. */}
                                {OpenFollowUpColumns.map((column) => (
                                    <Column key={column.dataField} {...column} />
                                ))}
                            </DataGrid>
                        </div>
                    </div>
                </TabItem>
                <TabItem title="Customer">
                    <div className="search-page-content">
                        {/* Mirrors ARD0009's grdTopCustomer: Customer, Name, Address 1/2, City,
                            State, Zip, Salesperson, Telephone. CustomerBrowseGrid is the shared
                            component behind that column set (also used by OM's Query Orders By
                            Customer follow-up popup) - the bare id/Lookup/GetCustomers endpoint
                            this used to call returns only Id + IdentityId. */}
                        <div className="search-page-grid-container">
                            <div style={{ flex: '0 0 auto', padding: '0 0 8px 0' }}>
                                <Button disabled={isStartFollowUpDisabled} onClick={handleStartFollowUpClick} type="default" text={MESSAGES.START_FOLLOW_UP}></Button>
                            </div>
                            {/* CustomerBrowseGrid's own DataGrid is height="100%", so it needs a
                                definite-height flex item to resolve against. */}
                            <div style={{ flex: '1 1 auto', minHeight: 0 }}>
                                <CustomerBrowseGrid onCustomerChanged={onCustomerChanged} />
                            </div>
                        </div>
                    </div>
                </TabItem>
            </TabPanel>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
